export const ALLOWED_POS_IDS = ['POS-001', 'POS-002', 'POS-003', 'POS-004'] as const
export type PosId = (typeof ALLOWED_POS_IDS)[number]
